export const translations = {
  es: {
    required: 'Este campo es obligatorio.',
    radio: 'Por favor, selecciona un valor.',
    select: 'Por favor, selecciona un valor.',
    'select-multiple': 'Por favor, selecciona al menos un valor.',
    emailMismatch: 'Por favor, introduce una dirección de correo válida.',
    urlMismatch: 'Por favor, introduce una URL.',
    numberMismatch: 'Por favor, introduce un número.',
    colorMismatch: 'Por favor, sigue el siguiente formato: #rrggbb',
    dateMismatch: 'Por favor, usa el formato AAAA-MM-DD.',
    timeMismatch: 'Por favor, usa el formato de 24 horas. Ej. 23:00',
    monthMismatch: 'Por favor, usa el formato AAAA-MM.',
    defaultMismatch: 'El campo no coincide con el formato solicitad',
    over: 'Por favor, selecciona un valor que no sea mayor que {max}.',
    under: 'Por favor, selecciona un valor que no sea menor que {min}.',
    overLength:
      'Por favor, acorta este texto a no más de {maxLength} caracteres. Actualmente estás usando {length} caracteres.',
    underLength:
      'Por favor, alarga este texto a {minLength} caracteres o más. Actualmente estás usando {length} caracteres.',
    checkboxSet: 'Por favor, elige al menos una opción.',
    valueMismatch: 'Please make sure the fields match.',
    helpPatternMismatch: 'Por favor, asegúrese de que se cumplan todos los requisitos.',
    calendarMismatch: 'El formato de la fecha no es válido.',
    phoneValidation: 'El formato del número de teléfono no es válido.',
  },
  en: {
    required: 'This field is required.',
    radio: 'Please select a value.',
    select: 'Please select a value.',
    'select-multiple': 'Please select at least one value.',
    emailMismatch: 'Please enter a valid email address.',
    urlMismatch: 'Please enter a URL.',
    numberMismatch: 'Please enter a number',
    colorMismatch: 'Please match the following format: #rrggbb',
    dateMismatch: 'Please use the YYYY-MM-DD format',
    timeMismatch: 'Please use the 24-hour time format. Ex. 23:00',
    monthMismatch: 'Please use the YYYY-MM format',
    defaultMismatch: 'Please match the requested format.',
    over: 'Please select a value that is no more than {max}.',
    under: 'Please select a value that is no less than {min}.',
    overLength:
      'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.',
    underLength:
      'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.',
    checkboxSet: 'Please choose at least one option',
    valueMismatch: 'Por favor, asegúrese de que los campos coincidan.',
    helpPatternMismatch: 'Please make sure all requirements are met.',
    calendarMismatch: 'The date format is not valid.',
    phoneValidation: 'The phone number format is not valid.',
  },
  pt: {
    required: 'Este campo é obrigatório.',
    radio: 'Por favor, selecione um valor.',
    select: 'Por favor, selecione um valor.',
    'select-multiple': 'Por favor, selecione pelo menos um valor.',
    emailMismatch: 'Por favor, insira um endereço de e-mail válido.',
    urlMismatch: 'Por favor, insira uma URL.',
    numberMismatch: 'Por favor, insira um número.',
    colorMismatch: 'Por favor, siga o seguinte formato: #rrggbb',
    dateMismatch: 'Por favor, use o formato AAAA-MM-DD.',
    timeMismatch: 'Por favor, use o formato de 24 horas. Ex. 23:00',
    monthMismatch: 'Por favor, use o formato AAAA-MM.',
    defaultMismatch: 'Por favor, siga o formato solicitado.',
    over: 'Por favor, selecione um valor que não seja maior que {max}.',
    under: 'Por favor, selecione um valor que não seja menor que {min}.',
    overLength:
      'Por favor, reduza este texto para no máximo {maxLength} caracteres. Atualmente, você está usando {length} caracteres.',
    underLength:
      'Por favor, aumente este texto para pelo menos {minLength} caracteres. Atualmente, você está usando {length} caracteres.',
    checkboxSet: 'Por favor, escolha pelo menos uma opção.',
    valueMismatch: 'Certifique-se de que os campos correspondam.',
    helpPatternMismatch: 'Certifique-se de que todos os requisitos são cumpridos.',
    calendarMismatch: 'O formato de data não é válido.',
    phoneValidation: 'O formato do número de telefone não é válido',
  },
  fr: {
    required: 'Ce champ est obligatoire.',
    radio: 'Veuillez sélectionner une valeur.',
    select: 'Veuillez sélectionner une valeur.',
    'select-multiple': 'Veuillez sélectionner au moins une valeur.',
    emailMismatch: 'Veuillez entrer une adresse e-mail valide.',
    urlMismatch: 'Veuillez entrer une URL.',
    numberMismatch: 'Veuillez entrer un nombre.',
    colorMismatch: 'Veuillez respecter le format suivant : #rrggbb',
    dateMismatch: 'Veuillez utiliser le format AAAA-MM-JJ.',
    timeMismatch: 'Veuillez utiliser le format horaire 24 heures. Ex. 23:00',
    monthMismatch: 'Veuillez utiliser le format AAAA-MM.',
    defaultMismatch: 'Veuillez respecter le format demandé.',
    over: 'Veuillez sélectionner une valeur qui ne dépasse pas {max}.',
    under: 'Veuillez sélectionner une valeur qui n’est pas inférieure à {min}.',
    overLength:
      'Veuillez raccourcir ce texte à un maximum de {maxLength} caractères. Vous utilisez actuellement {length} caractères.',
    underLength:
      'Veuillez allonger ce texte à au moins {minLength} caractères. Vous utilisez actuellement {length} caractères.',
    checkboxSet: 'Veuillez choisir au moins une option.',
    valueMismatch: 'Veuillez vous assurer que les champs correspondent.',
    helpPatternMismatch: 'Veuillez vous assurer que toutes les exigences sont remplies.',
    calendarMismatch: "Le format de date n'est pas valide.",
    phoneValidation: "Le format du numéro de téléphone n'est pas valide.",
  },
};
